import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Table, TableHead, TableRow, TableCell, TableBody, Chip } from "@mui/material";
import { toast } from "react-toastify";
import { getPrintHistory } from "./api/labelStudioApi";

const PrintHistoryPage = () => {
  const [history, setHistory] = useState([]);

  useEffect(() => {
    getPrintHistory()
      .then(setHistory)
      .catch(() => toast.error("Failed to load print history"));
  }, []);

  return (
    <Box>
      <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
        Print History
      </Typography>
      <Paper elevation={1} sx={{ borderRadius: 3, overflowX: "auto" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Product</TableCell>
              <TableCell>Template</TableCell>
              <TableCell>Batch</TableCell>
              <TableCell>Printer / Output</TableCell>
              <TableCell>Copies</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Printed At</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {history.map((h) => (
              <TableRow key={h.id} hover>
                <TableCell>{h.generatedLabel?.product?.productNameEn || "-"}</TableCell>
                <TableCell>{h.generatedLabel?.template?.name || "-"}</TableCell>
                <TableCell>{h.generatedLabel?.batchNumber || "-"}</TableCell>
                <TableCell>{h.printerType}</TableCell>
                <TableCell>{h.copies}</TableCell>
                <TableCell>
                  <Chip size="small" label={h.status} color={h.status === "SUCCESS" ? "success" : "error"} />
                </TableCell>
                <TableCell>{h.printedAt ? new Date(h.printedAt).toLocaleString() : "-"}</TableCell>
              </TableRow>
            ))}
            {history.length === 0 && (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No print history yet.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
};

export default PrintHistoryPage;
